import React, { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Button,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import "./role.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addNewCustomer,
  editCustomer,
  fetchCustomerById,
} from "../../store/slices/Customer/thunk"; 
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";
import { fetchCompany } from "../../store/slices/thunk";
import addBooking from "../Booking/add-Booking";
import user from "../user/user";

const Addrole = () => {

  const navigate = useNavigate();
  const { id } = useParams<any>();
  const dispatch: any = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allCompany, setAllCompany] = useState<any>([]);
  const [searchCompany, setSearchCompany] = React.useState("");

    const [companyId, setCompanyId] = useState<string>("");
     const [user, setUser] = useState({
        name: "",
        email: "",
        userName: "",
        password: "",
        userPermission: [
          {
            vehicle: {
              isAllList: false,
              isDetailView: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            vehicleGroup: {
              isAllList: false,
              isAddNew: false,
              isDelete: false,
            },
            driver: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            bookings: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            customer: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            fuel: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            reminder: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            incomeExpense: {
              isAllList: false,
              isEdit: false,
              isAdd: false,
              isDelete: false,
            },
            maintenance: {
              isAllList: false,
              isAdd: false,
            },
            availibity: {
              isAllList: false,
            },
            tracking: {
              isHistoryTracking: false,
              isLiveLocation: false,
            },
            geofence: {
              isAllList: false,
              isEventsList: false,
              isAdd: false,
              isDelete: false,
            },
            reports: {
              viewReports: false,
            },
            settings: {
              allSettings: false,
            },
          },
        ],
        _id: "",
      });
    const [addBooking, setAddBooking] = useState<any>(
      {
        company:{
           companyId: "",
          companyName: "",
        }
      }
    ) 
  // role ka state
  const [addRole, setAddRole] = useState({
    roleName: "",
    status: "active",
    _id: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchCustomerById(id));
        const { roleName, status, _id } = response.data;
        setAddRole({
          roleName,
          status,
          _id,
        });
      } else {
        setIsEdit(false);
        setAddRole({
          roleName: "",
          status: "active",
          _id: "",
        });
      }
    };
    fetchData();
  }, [id, dispatch]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAddRole((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
 useEffect(() => {
      const getAllCompany = async () => {
        const response: any = await dispatch(fetchCompany(1, 99999999, searchCompany,''));
        if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
          setAllCompany(response?.data?.data);
        } else {
          setAllCompany([]);
        }
        console.log(allCompany);
      };
  
      getAllCompany();
    }, [dispatch]);
  
  const handleChangeForCompany = (e: any) => {
    debugger
    const { value } = e.target;
    // (value);
        if (!value) {
      setAddBooking({
        ...addBooking,
        company: {
          companyId: "",
          companyName: "",
        },
      });
      return;
    }
    const selectedCompany: any = allCompany.find(
      (driver: any) => driver._id === value
    );

    if (selectedCompany) {
      setAddBooking({
        ...addBooking,
        company: {
          companyId: selectedCompany._id,
          companyName: selectedCompany.companyName,
        },
      });
    }
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEdit) {
        if (addRole.roleName === "" || addRole.status === "") {
          toast.error("Fill All Fields");
        } else {
          const res: any = await dispatch(editCustomer(addRole));
          if (res.data && res.isSuccess) {
            toast.success("Role Edited!");
            navigate("/role-list");
          } else {
            toast.error("Role Not Edit!");
          }
        }
      } else {
        if (addRole.roleName === "" || addRole.status === "") {
          toast.error("Fill All Fields");
        } else {
          const res: any = await dispatch(addNewCustomer(addRole));
          if (res.data && res.isSuccess) {
            toast.success("Role added!");
            navigate("/role-list");
          } else {
            toast.error("Role Not added!");
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const navigateToRoleList = () => {
    navigate("/role-list");
  };

 const handleCheckboxChange =
    (category: any, permission: any) => (event: any) => {
      const { checked } = event.target;
      setUser((prevUser: any) => {
        const updatedPermissions = prevUser.userPermission.map(
          (permissionSet: any, index: any) => {
            if (index === 0) {
              return {
                ...permissionSet,
                [category]: {
                  ...permissionSet[category],
                  [permission]: checked,
                },
              };
            }
            return permissionSet;
          }
        );

        return { ...prevUser, userPermission: updatedPermissions };
      });
 };


  return (
    <div className="boDy">
      <ToastContainer />
      <div
        className="box px-3 py-4"
        style={{ backgroundColor: "white", borderRadius: "12px", marginTop: "40px" }}
      >
        <div>
          <div className="d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
            
            <div className="d-flex flex-column">
<h5 className="fw-bolder">
              {isEdit ? "Edit Role" : "Add New Role"}
            </h5>
            <p className="" style={{ color: "#4b5563" }}>Fill in the details to create a new role</p>
          </div>
            <button
              type="button"
              onClick={navigateToRoleList}
              className="btn rounded-2"
              style={{ backgroundColor: "transparent", width: "fit-content" }}
            >
              <KeyboardBackspaceIcon />
              <span style={{ marginLeft: "10px" }}>Back To List</span>
            </button>
          </div>
        </div>
<div
              className="box1222 px-3 py-3 mt-3"
              style={{ borderRadius: "12px", backgroundColor: "white" }}
            >
        <div className="row">
            
            
              <div className="col-md-6">
                      <h6  style={{fontWeight:"700",color:"grey"}}>Title</h6>
                <TextField
                  id="outlined-role"
                  fullWidth
                  placeholder="Enter Role Title"
                  name="roleName"
                  type="text"
                  value={addRole.roleName}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
               <div className="col-md-6">
      <h6  style={{fontWeight:"700",color:"grey"}}>Email</h6>
                      <TextField
                  id="outlined-role"
                  fullWidth
                  placeholder="Enter Email Address"
                  name="roleName"
                  type="text"
                  value={addRole.roleName}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
borderRadius: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6 mt-3">
                                    <label
                                    htmlFor="contactNumber"
                                    style={{
                                      display: "block",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#374151",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    Company  
                                  </label>
                
                                    <div style={{ position: "relative", width: "100%" }} className="col-md-12">
                                      <Box>
                                                         <Autocomplete
                                                           options={allCompany}
                                                           getOptionLabel={(option: any) => option.companyName}
                                                           value={
                                                             allCompany.find(
                                                               (v: any) => v._id === addBooking.company?.companyId
                                                             ) || null
                                                           }
                                                           onInputChange={(event, newInputValue) => {
                                                             setSearchCompany(newInputValue);
                                                           }}
                                                           onChange={(event, newValue: any) => {
                                                             handleChangeForCompany({
                                                               target: { value: newValue ? newValue._id : "" },
                                                             });
                                                           }}
                                                           clearOnEscape
                                                           ListboxProps={{
                                                             sx: {
                                                               backgroundColor: "#fff",
                                                               color: "#000",
                                                               "& .MuiAutocomplete-option": {
                                                                 color: "#000",
                                                               },
                                                             },
                                                           }}
                                                           renderInput={(params) => (
                                                             <TextField
                                                               {...params}
                                                               label="Search or Select Company"
                                                             />
                                                           )}
                                                         />
                                                       </Box>
                                    <span
                                      style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        pointerEvents: "none",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        style={{ color: "#6B7280" }}
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M19 9l-7 7-7-7"
                                        />
                                      </svg>
                                    </span>
                                  </div>
              </div>

            </div>
        <div className="mt-5">
          <div className="container">
            <h5 className="usEr">User Permission</h5>
          </div>

          <div className="container mt-5">
            <div className="row">
              <div className="col-md-3">
                <h6>Vehicle</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isAllList}
                      onChange={handleCheckboxChange("vehicle", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isDetailView}
                      onChange={handleCheckboxChange("vehicle", "isDetailView")}
                    />
                  }
                  label={<Typography fontWeight={700}>Detail View</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isEdit}
                      onChange={handleCheckboxChange("vehicle", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2 d-flex">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isAdd}
                      onChange={handleCheckboxChange("vehicle", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add</Typography>}
                />
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isDelete}
                      onChange={handleCheckboxChange("vehicle", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2"></div>{" "}
            </div>
          </div>

          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Vehicle Group</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "vehicleGroup",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isAddNew
                      }
                      onChange={handleCheckboxChange("vehicleGroup", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isDelete
                      }
                      onChange={handleCheckboxChange(
                        "vehicleGroup",
                        "isDelete"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Driver</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isAllList}
                      onChange={handleCheckboxChange("driver", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isEdit}
                      onChange={handleCheckboxChange("driver", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isDelete}
                      onChange={handleCheckboxChange("driver", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isAdd}
                      onChange={handleCheckboxChange("driver", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Booking</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isAllList}
                      onChange={handleCheckboxChange("bookings", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All Booking</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isEdit}
                      onChange={handleCheckboxChange("bookings", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isAdd}
                      onChange={handleCheckboxChange("bookings", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isDelete}
                      onChange={handleCheckboxChange("bookings", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Customer</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isAllList}
                      onChange={handleCheckboxChange("customer", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isEdit}
                      onChange={handleCheckboxChange("customer", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isAdd}
                      onChange={handleCheckboxChange("customer", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isDelete}
                      onChange={handleCheckboxChange("customer", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          {/* <div className="container mt-2 ">
            <div className="row">
              <div className="col-md-3">
                <h6>Fuel</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isAllList}
                      onChange={handleCheckboxChange("fuel", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>Fuel List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isEdit}
                      onChange={handleCheckboxChange("fuel", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isAdd}
                      onChange={handleCheckboxChange("fuel", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isDelete}
                      onChange={handleCheckboxChange("fuel", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div> */}
          {/* <div className="container mt-2 mb-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Reminder</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isAllList}
                      onChange={handleCheckboxChange("reminder", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isDelete}
                      onChange={handleCheckboxChange("reminder", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isAdd}
                      onChange={handleCheckboxChange("reminder", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isDelete}
                      onChange={handleCheckboxChange("reminder", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div> */}
          {/* <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Income Expense</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.incomeExpense?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "incomeExpense",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.incomeExpense?.isEdit}
                      onChange={handleCheckboxChange("incomeExpense", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.incomeExpense?.isAdd}
                      onChange={handleCheckboxChange("incomeExpense", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.incomeExpense?.isDelete
                      }
                      onChange={handleCheckboxChange(
                        "incomeExpense",
                        "isDelete"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div> */}
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Maintenace</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.maintenance?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "maintenance",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Maintenace</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.maintenance?.isAdd}
                      onChange={handleCheckboxChange("maintenance", "isAdd")}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>Maintenace Add</Typography>
                  }
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Availablity</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.availibity?.isAllList}
                      onChange={handleCheckboxChange("availibity", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>Availablity</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Tracking</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.tracking?.isHistoryTracking
                      }
                      onChange={handleCheckboxChange(
                        "tracking",
                        "isHistoryTracking"
                      )}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>History Tracking</Typography>
                  }
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.tracking?.isLiveLocation
                      }
                      onChange={handleCheckboxChange(
                        "tracking",
                        "isLiveLocation"
                      )}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>Live Location</Typography>
                  }
                />
              </div>{" "}
            </div>
          </div>

          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Geofence</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isAdd}
                      onChange={handleCheckboxChange("geofence", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isAllList}
                      onChange={handleCheckboxChange("geofence", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isDelete}
                      onChange={handleCheckboxChange("geofence", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.geofence?.isEventsList
                      }
                      onChange={handleCheckboxChange(
                        "geofence",
                        "isEventsList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Events</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Reports</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reports?.viewReports}
                      onChange={handleCheckboxChange("reports", "viewReports")}
                    />
                  }
                  label={<Typography fontWeight={700}>View Reports</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2 mb-3">
            <div className="row">
              <div className="col-md-3">
                <h6>Settings</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.settings?.allSettings}
                      onChange={handleCheckboxChange("settings", "allSettings")}
                    />
                  }
                  label={<Typography fontWeight={700}>All Settings</Typography>}
                />
              </div>{" "}
            </div>
          </div>
        </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12 p-0">
                <div
                  className="mt-4 aDD p-0"
                  style={{ backgroundColor: "transparent" }}
                >
                  <Button
                    onClick={handleSubmit}
                    disabled={loading}
                    style={{ textTransform: "none", fontWeight: "600", width: "auto" }}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : isEdit ? (
                      "Edit Role"
                    ) : (
                      "Add Role"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default Addrole;
